import { render, staticRenderFns } from "./_base-logoBar.vue?vue&type=template&id=0b02fa4a&scoped=true&"
import script from "./_base-logoBar.vue?vue&type=script&lang=js&"
export * from "./_base-logoBar.vue?vue&type=script&lang=js&"
import style0 from "./_base-logoBar.vue?vue&type=style&index=0&id=0b02fa4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b02fa4a",
  null
  
)

export default component.exports